import React, { Component } from 'react';
import RiskLevel from '../risk-level/RiskLevel';

class RiskAttributeEntry extends Component {
    render() {
        return (
            <div className="risk-factor-attribute-entry">
                <span className="risk-factor-attribute-info">
                    {this.props.name}
                </span>
                <span className="risk-factor-attribute-risk-level">
                    <RiskLevel riskLevel={this.props.riskLevel} />
                </span>
            </div>
        );
    }
}

export default RiskAttributeEntry;
